import React from 'react';
import ReactDOM from 'react-dom';
import { useNotesModal } from '../contexts/NotesModalContext';
import NotesModal from './NotesModal';

const GlobalNotesModal = () => {
  const { isVisible, ticker, notes, hideNotesModal, updateNotes } = useNotesModal();

  if (!isVisible || !ticker) {
    return null;
  }

  // Use a portal to render the modal at the document body level
  // This ensures it stays visible regardless of route changes
  return ReactDOM.createPortal(
    <NotesModal
      show={isVisible}
      onHide={hideNotesModal}
      ticker={ticker}
      notes={notes}
      setNotesForTicker={updateNotes}
      floating={true}
    />,
    document.body
  );
};

export default GlobalNotesModal;
